export default __webpack_public_path__ + "static/media/BI.4f89210b.svg";